/* eslint-disable */
import $ from 'jquery'


import Flickity from 'flickity'
import 'flickity-imagesloaded'
import 'flickity-fade'
import 'flickity-hash'

const cardSliders = [...document.querySelectorAll( '.card-slider' )]
const flktys = []

const init = () => {

    if ( cardSliders ) {
      
        cardSliders.forEach( ( s ) => {
          const slider = new Flickity( s, {
            freeScroll: true,
            contain: true,
            prevNextButtons: false,
            pageDots: true,
            cellAlign: 'left',
            // imagesLoaded: true,
            // fade: true,
            groupCells: true,
            lazyLoad: 2
          })

          flktys.push(slider)
      
          // window.addEventListener( 'load', function() {
          //   slider.resize()
          //   return slider
          // })
  
          // window.addEventListener( 'resize', function() {
          // })
      
        })
      
    }

}


export default {
  init,
}

